export function getTodayDateString(): string {
    return new Date().toISOString().split('T')[0];
  }
  
  export function getDateRange(dateString: string): { start: string; end: string } {
    return {
      start: `${dateString}T00:00:00Z`,
      end: `${dateString}T23:59:59Z`
    };
  }
  
  export function formatDate(dateString: string | Date): string {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date);
  }

  export function formatScheduledStartTime(scheduledStartTime: string | null): string {
    if (!scheduledStartTime) return '配信時間未定';
    
    const date = new Date(scheduledStartTime);
    const now = new Date();
    const diffTime = date.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
    if (diffDays === 0) {
      return `今日 ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    } else if (diffDays === 1) {
      return `明日 ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    } else if (diffDays > 1 && diffDays <= 7) {
      const dayNames = ['日', '月', '火', '水', '木', '金', '土'];
      return `${dayNames[date.getDay()]}曜 ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    } else {
      return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
  }

  export function formatTime(date: Date): string {
    return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
  }

  export function formatRelativeTime(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    
    // 将来の日付の場合
    if (diffMs < 0) {
      const absDiffMs = Math.abs(diffMs);
      const minutes = Math.floor(absDiffMs / (1000 * 60));
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      
      if (days > 0) {
        return `${days}日後`;
      } else if (hours > 0) {
        return `${hours}時間後`;
      } else {
        return `${minutes}分後`;
      }
    }
    
    // 過去の日付の場合
    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    
    if (days > 0) {
      return days === 1 ? '昨日' : `${days}日前`;
    } else if (hours > 0) {
      return `${hours}時間前`;
    } else if (minutes > 0) {
      return `${minutes}分前`;
    } else {
      return '今';
    }
  }